import { render, staticRenderFns } from "./AddTestimonial.vue?vue&type=template&id=5a18d662&scoped=true"
import script from "./AddTestimonial.vue?vue&type=script&lang=js"
export * from "./AddTestimonial.vue?vue&type=script&lang=js"
import style0 from "./AddTestimonial.vue?vue&type=style&index=0&id=5a18d662&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a18d662",
  null
  
)

export default component.exports